<template>
  <div>
    <modals-container name="modal1" />
    <v-dialog/>
    <div class="class_add_top">
      <a class="back" onclick="history.go(-1)">
        返回
      </a>
      <span v-if="isEdit">编辑</span><span v-if="!isEdit">新增</span>公告
    </div>
    <form class="class_add_con" data-vv-scope="form" novalidate>
      <table width="100%" border="0" cellspacing="0" cellpadding="0">
        <tr class="tita">
          <td class="left_td">基本信息</td>
          <td>&nbsp;</td>
        </tr>
        <tr>
          <td class="left_td pt30">标题：</td>
          <td class="pt20"><input type="text" name="title" v-validate="'required'" v-model="form.title" placeholder="60字以内" class="put_495" /></td>
        </tr>
        <div class="error_msg">{{ errors.first('form.title') }}</div>
        <tr>
          <td class="left_td">类型：</td>
          <td>
            <select name="infoType" class="all_select" v-validate="'required'" v-model="form.type">
              <option value="">选择公告类型</option>
              <option v-for="item in pool.information_type" v-bind:key="item.value" :value="item.value">{{item.label}}</option>
            </select>
          </td>
        </tr>
        <div class="error_msg">{{ errors.first('form.infoType') }}</div>
        <tr>
          <td class="left_td">封面：</td>
          <td class="rdiv">
            <img v-if="form.cover && form.cover!==''" :src="form.cover"  class="upload_img" />
            <UploadOSS :uploadOSSConf="uploadOSSConf" :DOM_ID="'cover'" v-if="uploadOSSConf.STS!=null" @success = "OSSUploadSuccess"></UploadOSS>
            <p class="mt10"><span class="tips_text">建议图片长280px宽150px，支持jpg、jpeg、png，图片大小不超过2MB</span></p>
          </td>
        </tr>
        <tr>
          <td class="left_td pt30" valign="top">内容：</td>
          <td valign="top" class="pt20">
            <Ueditor :value="ueditor.value" :config="ueditor.config" ref="ue"></Ueditor>
            <br><br>
          </td>
        </tr>
      </table>
      <p class="btn_center">
        <input name="" type="button" class="all_btn" value="提交完成" @click="validateForm('form')" />
      </p>
    </form>
    <div class="clear"></div>
  </div>
</template>

<script>
  import config from '@/config'
  import api from '@/api'
  import { mapActions, mapGetters } from 'vuex'
  import '@/utils/validator.js'
  import utils from '@/utils'
  import Bus from '@/utils/bus'
  import Ueditor from '@/components/common/UE/ue'
  import UploadOSS from '@/components/common/upload/uploadOSS.vue'
  export default {
    components: { Ueditor, UploadOSS },
    data () {
      return {
        form: {
          type: ''
        },
        pool: {
          information_type: []
        },
        ueditor: {
          value: '',
          config: {
            initialFrameWidth: 790,
            initialFrameHeight: 227
          }
        },
        prefix: this.$route.meta.prefix || '',
        uploadOSSConf: { showMode: '1', style: 'img_upload', typeArr: 'image/png,image/jpg,image/jpeg', catalog: 'byl', fileName: '', maxSize: '2000000', STS: null }
      }
    },
    mounted () {
      this.getSTS()
      this.OSSUploadSuccess()
      this.getTypes('information_type')
      if (this.isEdit) { // 通过 id 取信息并且要给select赋值
        this.getModel(this.$route.params.id)
        this.$on('data-prepared', function (data) {
          this.ueditor.value = this.$refs.ue.setUEContent(data.content)
        });
      }
    },
    computed: {
      isEdit () {
        return this.$route.params.id && this.$route.params.id !== 'void'
      }
    },
    methods: {
      popup (msg) {
        this.$toasted.show(msg)
      },
      confirmBox (o) {
        var that = this
        this.$modal.show('dialog', {
          title: '提交',
          text: '确认提交吗？',
          buttons: [
            {
              title: '确认',
              default: true,
              handler: utils.debounce(() => {
                if (o.yes && o.yes instanceof Function) {
                  o.yes()
                  that.$modal.hide('dialog') // !!!必须清掉模态框，否则在别的页面按enter键会触发方法的
                }
              }, 1000)
            },
            {
              title: '取消'
            }
          ]
        })
      },
      validateForm (scope) {
        var bus = this
        var _dealParams = function () { // 处理发送给后台的数据结构
          bus.form.content = bus.$refs.ue.getUEContent()
        }
        this.$validator.validateAll(scope).then(function (result) {
          if (result) {
            if (bus.isEdit) { // 编辑
              _dealParams()
              if (!bus.form.content) {
                bus.popup('内容不能为空')
              } else {
                bus.confirmBox({
                  yes: function () {
                    api.post(config.bylBaseCenterPath, '/noticeinfo/save', bus.form, function (r) { // 正常
                      bus.popup('保存成功')
                      bus.$router.push(bus.prefix + '/org/informationList')
                    })
                  }
                })
              }
            } else { // 新增
              _dealParams()
              bus.form.audit = '0'
              bus.form.state = '0'
              if (!bus.form.content) {
                bus.popup('内容不能为空')
              } else {
                bus.confirmBox({
                  yes: function () {
                    api.post(config.bylBaseCenterPath, '/noticeinfo/save', bus.form, function (r) { // 正常
                      bus.popup('创建公告成功')
                      bus.$router.push(bus.prefix + '/org/informationList')
                    })
                  }
                })
              }
            }
          } else {
            bus.popup('请确保信息正确与完整')
            return false
          }
        })
      },
      to (path) {
        this.$router.push(path)
      },
      getModel (id) {
        var that = this
        api.post(config.bylBaseCenterPath, '/noticeinfo/get', { id: id }, function (r) { // 正常
          that.form = r.data
          that.$emit('data-prepared', that.form)
        })
      },
      OSSUploadSuccess (r) {
        if (r && r != '') {
          this.$set(this.form, r.dom_id, r.res.requestUrls[0])
        }
      },
      getSTS () {
        this.$api.get(this.$global.resourceApiPath, '/common/getSTS', {}, r => {
          let STS = [r.data.expiration, r.data.accessKeyId, r.data.accessKeySecret, r.data.securityToken, r.data.endpointClean, r.data.bucket, r.data.region]
          this.uploadOSSConf.STS = STS
        })
      },
      getTypes (type) {
        api.get(config.bylBaseCenterPath, '/dict/getDictList', {type: type}, (r) => {
          if (r.data) {
            this.pool.information_type = r.data
          } else {
            this.pool.information_type = []
          }
        })
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/page/byl/org/information/model.vue